import { getRequest, getSchedulingRequest, postSchedulingRequest } from "./ApiService";

export function getSchedules(){
    return getRequest('schedulingList')
}

export function getSchedulingData(tenantId, schedulingId, academicId){
    let queryParams = {filter_available: true};
    if (academicId) {
        queryParams.academic_id = academicId;
    }
    return getRequest('schedulingData', {id: schedulingId}, queryParams)
}

export function postSchedulingSubscription(tenantId, data){
    data.tenant_id = tenantId;
    return postSchedulingRequest(tenantId, 'newSubscription', {}, data)
}

export function getSubscription(tenantId, subscriptionId){
    let data = {tenant_id: tenantId};
    return getSchedulingRequest(tenantId, 'getSubscription', {id: subscriptionId}, data)
}

export function subscriptionCancel(tenantId, subscriptionId){
    let data = {tenant_id: tenantId};
    return postSchedulingRequest(tenantId, 'cancelSubscription', {id: subscriptionId}, data)
}

export function getSettings(tenantId, parameterId){
    return getSchedulingRequest(tenantId, 'settings', {id: parameterId}, {tenant: tenantId})
}
